<template lang='pug'>
  lazy-component(@show='loadYouTube')
    .billboard-video.modal.fade.media-modal.js-video-modal(:id='`billboard-video-${videoId}`' aria-hidden='true' role='dialog' tabindex='-1')
      .modal-dialog(role='document')
        .modal-content
          .modal-header
            h3.h3.video-title(v-text='videoTitle')
            button.close(type='button' data-dismiss='modal' aria-label='Close')
          .modal-body.text-center
            .modal-video
              iframe(:id='videoId' frameborder='0' width='560' height='315' :src='`//www.youtube.com/embed/${videoId}?rel=0&amp;enablejsapi=1&amp;modestbranding=1`' allowFullScreen='true' :title='videoTitle')
</template>

<script>
import { loadYouTube } from '@/modules/services/remote-resources'

export default {
  props: [
    'videoId',
    'videoTitle'
  ],

  methods: {
    loadYouTube
  }
}
</script>

<style scoped lang='scss'>
  .video-title {
    @include font-weight-medium;
    font-size: 16px;
    text-align: center;
    width: 100%;
  }
</style>
